// @ts-nocheck
import useCanSeePrices from "@store/Framework/Store/Data/Accounts/Hooks/useCanSeePrices";
import PriceMatrix, { PriceMatrixStyles } from "@store/Library/Components/Common/PriceMatrix";
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { ProductContext, ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import {
    isWishListLineDiscontinued,
    isWishListLineRestricted,
} from "@insite/client-framework/Store/Data/WishListLines/WishListLinesSelectors";

import setWishListLineIsSelected from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/SetWishListLineIsSelected";
import updateQuantity from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/UpdateQuantity";
import updateUnitOfMeasure from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/UpdateUnitOfMeasure";
import updateWishListLineQuantities from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/UpdateWishListLineQuantities";
import translate from "@insite/client-framework/Translate";
import {
    AvailabilityMessageType,
    ProductModel,
    ProductPriceDto,
    WishListLineModel,
    WishListModel,
} from "@insite/client-framework/Types/ApiModels";
import ProductAddToCartButton from "@insite/content-library/Components/ProductAddToCartButton";
// import { ProductAvailabilityStyles } from "@insite/content-library/Components/ProductAvailability"; // bunzl Custom code
import ProductBrand, { ProductBrandStyles } from "@insite/content-library/Components/ProductBrand";
import ProductContextAvailability from "@insite/content-library/Components/ProductContextAvailability";
import ProductDescription, { ProductDescriptionStyles } from "@insite/content-library/Components/ProductDescription";
import ProductPartNumbers, { ProductPartNumbersStyles } from "@insite/content-library/Components/ProductPartNumbers";
// import ProductPrice, { ProductPriceStyles } from "@insite/content-library/Components/ProductPrice"; // Bunzl Custom Code
import ProductQuantityBreakPricing, {
    ProductQuantityBreakPricingStyles,
} from "@insite/content-library/Components/ProductQuantityBreakPricing";
// import ProductQuantityOrdered from "@insite/content-library/Components/ProductQuantityOrdered"; // Starter Custom Code
import ProductUnitOfMeasureSelect from "@insite/content-library/Components/ProductUnitOfMeasureSelect";
import SmallHeadingAndText, { SmallHeadingAndTextStyles } from "@insite/content-library/Components/SmallHeadingAndText";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import Checkbox, { CheckboxPresentationProps, CheckboxProps } from "@insite/mobius/Checkbox";
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable"; // Starter Custom Code
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
// import Icon, { IconMemo, IconPresentationProps, IconProps } from "@insite/mobius/Icon";Starter Custom Code
import Check from "@insite/mobius/Icons/Check";
import RefreshCw from "@insite/mobius/Icons/RefreshCw";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import OverflowMenu from "@insite/mobius/OverflowMenu";
import { SelectPresentationProps } from "@insite/mobius/Select";
import TextField, { TextFieldProps } from "@insite/mobius/TextField";
import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography"; // Starter Custom Code
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import cloneDeep from "lodash/cloneDeep";
import React, { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

// Starter Custom Code
import useHandleMinimumMultupleSalesQuantity from "@store/Framework/Common/Hooks/useHandleMinimumMultupleSalesQuantity";
import AddToCartButtonWithIcon, {
    AddToCartButtonWithIconStyles,
} from "@store/Library/Components/Common/AddToCartButtonWithIcon";
import MinimumMultipleQuantityWarnings from "@store/Library/Components/Common/MinimumMultipleQuantityWarnings";
import ProductImage, { ProductImageStyles } from "@store/Overrides/Components/ProductImage";
import ProductPrice, { ProductPriceStyles } from "@store/Overrides/Components/ProductPrice";
import LocalizedCurrency from "@insite/content-library/Components/LocalizedCurrency";
import Icon, { IconMemo, IconPresentationProps, IconProps } from "@insite/mobius/Icon";
import getColor from "@insite/mobius/utilities/getColor";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import CheckmarkCircle2Fill from "@store/Library/Components/Toolkit/Icons/CheckmarkCircle2/CheckmarkCircle2Fill";
import Refresh from "@store/Library/Components/Toolkit/Icons/Refresh";
import { productLineProps as productLine } from "@store/Themes/common/props/productLine";
import ProductQuantityOrdered from "@store/Overrides/Components/ProductQuantityOrdered";
import { contentSpacingStyles } from "@store/Themes/common/mixins/spacing";
import { productLineProps } from "@store/Themes/common/props/productLineProps";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";

import { linkStyles } from "@store/Themes/common/mixins/link";
// Store Custom Code
import useWidgetBadges from "@insite/client-framework/Common/Hooks/useWidgetBadges";
import updateWishListLine from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/UpdateWishListLine";
import Move from "@store/Library/Components/Toolkit/Icons/Move";
import Trash2Fill from "@store/Library/Components/Toolkit/Icons/Trash2/Trash2Fill";
import ProductTextBadges, { ProductTextBadgesStyles } from "@store/Overrides/Components/ProductTextBadges";
import { imageStyles } from "@store/Themes/common/mixins/image";
import ProductInventoryDetailMessage from "@store/Library/Components/Common/ProductInventoryDetailMessage";
import { ProductAvailabilityStyles } from "@store/Overrides/Components/ProductAvailability";
import ProductImageBadges, {
    BadgeSizes,
    ProductImageBadgesStyles,
} from "@store/Overrides/Components/ProductImageBadges";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import { getBreakpointMediaQuery } from "@toolkit/Framework/Common/Utilities/mediaQueries";
import { SortableHandle } from "react-sortable-hoc";
// eslint-disable-next-line spire/fenced-imports
import Decimal from "decimal.js";

// Store Custom Code - added export
export interface OwnProps {
    wishList: WishListModel;
    wishListLine: WishListLineModel;
    productInfo: ProductInfo;
    onDeleteClick: (wishListLine: WishListLineModel) => void;
    onEditNotesClick: (wishListLine: WishListLineModel) => void;
    showImageBadges: boolean;
    maximumNumberOfImageBadges: number;
    showTextBadges: boolean;
    maximumNumberOfTextBadges: number;
    /* Store Custom Code - Start */
    canDrag?: boolean;
    isEditingSortOrder?: boolean;
    customWishListLineUpdate?: (wishListLine: WishListLineModel) => void;
    quantityUpdateOnSuccess?: () => void;
    /* Store Custom Code - End */
}

const mapStateToProps = (state: ApplicationState, ownProps: OwnProps) => ({
    isSelected: !!state.pages.myListDetails.selectedWishListLineIds.find(o => o === ownProps.wishListLine.id),
    settingsCollection: getSettingsCollection(state),
    isQuantityUpdated: state.pages.myListDetails.wishListLinesWithUpdatedQuantity[ownProps.wishListLine.id],
});

const mapDispatchToProps = {
    setWishListLineIsSelected,
    updateUnitOfMeasure,
    updateQuantity,
    updateWishListLineQuantities,
    updateWishListLine,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface MyListsDetailsProductListLineStyles {
    editNotesLink?: LinkPresentationProps;
    lineInnerContainer?: GridContainerProps;
    selectedCheckboxHidden?: HiddenProps;
    imageGridItem?: GridItemProps;
    selectedCheckbox?: CheckboxPresentationProps;
    imageWrapper?: InjectableCss;
    editNotesHidden?: HiddenProps;
    productImageStyles?: ProductImageStyles;
    descriptionGridItem?: GridItemProps;
    productBrandStyles?: ProductBrandStyles;
    productDescriptionStyles?: ProductDescriptionStyles;
    productPartNumbersStyles?: ProductPartNumbersStyles;
    notesStyles?: SmallHeadingAndTextStyles;
    overflowMenuGridItem?: GridItemProps;
    partNumbersHidden?: HiddenProps;
    partNumbersGridItem?: GridItemProps;
    priceAndAvailabilityGridItem?: GridItemProps;
    priceAndAvailabilityInnerContainer?: GridContainerProps;
    priceGridItem?: GridItemProps;
    productPriceStyles?: ProductPriceStyles;
    quantityBreakPricing?: ProductQuantityBreakPricingStyles;
    uomAndQuantityGridItem?: GridItemProps;
    uomAndQuantityInnerContainer?: GridContainerProps;
    uomGridItem?: GridItemProps;
    productUnitOfMeasureSelectStyles?: SelectPresentationProps;
    quantityGridItem?: GridItemProps;
    productQuantityOrderedStyles?: TextFieldProps;
    availabilityGridItem?: GridItemProps;
    productAvailabilityStyles?: ProductAvailabilityStyles;
    notesHidden?: HiddenProps;
    notesGridItem?: GridItemProps;
    buttonsGridItem?: GridItemProps;
    addToCartButton?: AddToCartButtonWithIconStyles;
    deleteLinkHidden?: HiddenProps;
    deleteLink?: LinkPresentationProps;
    updateQuantityWrapper?: InjectableCss;
    updateQuantityLink?: LinkPresentationProps;
    quantityUpdatedIcon?: IconPresentationProps;
    quantityUpdatedText?: TypographyPresentationProps;
    restrictedDescriptionGridItem?: GridItemProps;
    restrictedDescriptionText?: TypographyPresentationProps;
    restrictedMessageText?: TypographyPresentationProps;
    restrictedRemoveItemLink?: LinkPresentationProps;
    textBadgeStyles?: ProductTextBadgesStyles;
    imageBadgeStyles?: ProductImageBadgesStyles;
    // Starter Custom Code
    sortText?: TypographyPresentationProps;
    sortOrderWrapper?: InjectableCss;
    dragHandleIcon?: IconPresentationProps;
    sortOrderTextField?: TextFieldProps;
    actionDeleteButton?: ButtonPresentationProps;
    trashIcon?: IconProps;
    productLineInfo?: GridItemProps;
    productGridItem?: GridItemProps;
    productControlsGridItem?: GridItemProps;
    productControls?: InjectableCss;
    productControlsItem?: InjectableCss;
    badgesGridItem?: GridItemProps;
    productInfosWrapper?: InjectableCss;
    mobileProductControls?: InjectableCss;
    mobileQtyAndExtendedPrice?: InjectableCss;
    wrapper?: InjectableCss;
    extendedUnitNetPriceText?: TypographyProps;
    removeListLineIcon?: IconPresentationProps;
    removeProductButton?: ClickablePresentationProps;
    priceMatrixDesktop?: PriceMatrixStyles;
    priceMatrixMobile?: PriceMatrixStyles;
    extendedMobilePrice?: TypographyProps;
    deleteButtonWrapper?: InjectableCss;
    // Store Custom Code
    checkboxSortOrderWrapper?: InjectableCss;
    imageBadgeColumn?: InjectableCss;
    badgeWrapper?: InjectableCss;
}

export const productListLineStyles: MyListsDetailsProductListLineStyles = {
    /* Starter Custom Code - Start */
    textBadgeStyles: {
        tagWrapper: {
            extendedStyles: {
                item: {
                    css: css`
                        max-height: ${pxToRem(34)};
                    `,
                },
                content: {
                    css: css`
                        display: flex;

                        align-items: center;
                    `,
                },
                wrapper: {
                    css: css`
                        display: flex;
                    `,
                },
            },
        },
    },

    badgeWrapper: {
        css: css`
            display: flex;
            column-gap: 0.25rem;
            row-gap: 0.5rem;
            flex-wrap: wrap;
            ${breakpoint("sm", "down")} {
                /* flex-direction: column; */
                margin-block: 0.3125rem;
                gap: 0.5rem;
            }
        `,
    },
    imageBadgeColumn: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 30%;
            gap: 0.25rem;
            // moved margin to the wrapping column instead of the image so that badges maintain spacing from the next element
            ${productLineProps.productImage?.linkWrappingImage?.css}
        `,
    },
    imageBadgeStyles: {
        badgeImageProps: {
            style: {
                width: "auto",
                height: "100%",
            },
        },
        flexWrapper: {
            extendedStyles: {
                content: {
                    css: css`
                        display: flex;
                        align-items: center;
                    `,
                },
                wrapper: {
                    css: css`
                        display: flex;
                        margin-bottom: 0;
                    `,
                },
            },
        },
        imageBadgeWrapperStyles: {
            css: css`
                height: ${pxToRem(34)};
            `,
        },
    },
    checkboxSortOrderWrapper: {
        css: css`
            flex-direction: column;
            display: flex;
            row-gap: 0.5rem;
        `,
    },
    sortOrderTextField: {
        cssOverrides: {
            formField: css`
                width: 5rem;
            `,
            inputSelect: css`
                max-width: 2.5rem;
                text-align: center;
            `,
        },
    },
    sortOrderWrapper: {
        css: css`
            display: flex;
            cursor: move;
        `,
    },

    dragHandleIcon: {
        src: Move,
        size: 28,
        color: "primary.main",
    },
    sortText: {
        css: css`
            margin-left: ${pxToRem(8)};
            font-size: ${x => x.theme.design.typography.size.small};
        `,
    },
    // Store Custom Code
    deleteButtonWrapper: {
        css: css`
            ${breakpoint("sm", "down")} {
                position: absolute;
                right: 0;
                top: 0.5rem;
            }
            min-width: ${pxToRem(36)};
            margin-block: auto;
            margin-left: ${pxToRem(16)};
        `,
    },
    extendedMobilePrice: {
        css: css`
            color: ${getColor("primary")};
        `,
    },
    priceMatrixMobile: {
        wrapper: {
            css: css`
                margin-top: 0.5rem;
            `,
        },
    },

    priceMatrixDesktop: {
        wrapper: {
            css: css`
                @media (max-width: 1024px) {
                    display: none;
                }
            `,
        },
    },
    editNotesLink: {
        typographyProps: { size: 12 },
        css: css`
            margin-top: ${pxToRem(5)};
        `,
    },
    lineInnerContainer: {
        gap: 20,
        offsetCss: css`
            display: flex;
            flex-wrap: nowrap !important;

            ${breakpointValues(
                ["flex-start !important", null, null, "center !important", "center !important"],
                ["align-items"],
            )}
        `,
    },
    selectedCheckboxHidden: { below: "md" },
    imageGridItem: {
        width: [3, 3, 2, 2, 1],
        printWidth: 1,
    },
    selectedCheckbox: {
        sizeVariant: "small",
        css: css`
            @media print {
                display: none;
            }
            margin-right: ${pxToRem(10)};
        `,
    },
    imageWrapper: {
        css: css`
            @media print {
                max-height: ${pxToRem(83)};
                max-width: ${pxToRem(83)};
            }
            width: 100%;
            min-width: ${pxToRem(50)};
            flex-direction: column;
        `,
    },
    editNotesHidden: { below: "md" },
    descriptionGridItem: {
        width: [8, 8, 4, 4, 4],
        printWidth: 6,
        css: css`
            flex-direction: column;
        `,
    },
    overflowMenuGridItem: {
        width: [1, 1, 0, 0, 0],
        printWidth: 0,
    },
    partNumbersHidden: {
        below: "md",
        css: css`
            @media print {
                display: block;
            }
            width: 100%;
        `,
    },
    partNumbersGridItem: {
        width: 12,
        css: css`
            padding-left: 0;
        `,
    },
    priceAndAvailabilityGridItem: {
        width: [12, 12, 4, 4, 5],
        printWidth: 5,
    },
    priceAndAvailabilityInnerContainer: { gap: 10 },
    priceGridItem: {
        width: [12, 12, 12, 12, 5],
        printWidth: 5,
        css: css`
            flex-direction: column;
        `,
    },
    quantityBreakPricing: {
        viewLink: { typographyProps: { size: 12 } },
    },
    uomAndQuantityGridItem: {
        width: [12, 12, 12, 12, 7],
        printWidth: 7,
    },
    uomAndQuantityInnerContainer: {
        gap: 10,
        css: css`
            @media print {
                input,
                select {
                    height: ${pxToRem(18)} !important;
                    font-size: ${pxToRem(11)} !important;
                }
            }
        `,
    },
    uomGridItem: { width: 9, printWidth: 6 },
    quantityGridItem: { width: 3, printWidth: 6 },
    productUnitOfMeasureSelectStyles: {
        labelProps: {
            css: css`
                @media print {
                    font-size: ${pxToRem(12)};
                }
            `,
        },
        iconProps: {
            css: css`
                @media print {
                    display: none;
                }
            `,
        },
    },
    availabilityGridItem: { width: 12 },
    buttonsGridItem: {
        width: [12, 12, 2, 2, 2],
        printWidth: 0,
        css: css`
            min-width: 36px;
            align-items: center;
        `,
    },
    notesHidden: {
        above: "sm",
        css: css`
            @media print {
                display: none;
            }
            width: 100%;
        `,
    },
    notesGridItem: { width: 12 },
    addToCartButton: {
        button: {
            typographyProps: {
                css: css`
                    @media (min-width: 1200px) and (max-width: 1500px) {
                        font-size: ${pxToRem(14)};
                    }
                `,
            },
            css: css`
                ${({ theme }) => theme.button?.primary?.css}
                min-width: 10em;
                /* Bunzl Custom Code */
                margin-block: ${pxToRem(8)};
                align-self: center;
                & span:first-of-type {
                    @media (min-width: 1200px) and (max-width: 1350px) {
                        margin-right: ${pxToRem(14)};
                    }
                }
            `,
        },
    },
    deleteLinkHidden: {
        below: "md",
        css: css`
            display: flex;
            width: 100%;
            flex-direction: column;
            align-items: center;
        `,
    },
    deleteLink: {
        typographyProps: {
            css: css`
                font-size: ${x => x.theme.design.typography.size.smallest};
            `,
        },
        css: css`
            margin-top: ${pxToRem(10)};
        `,
    },
    updateQuantityWrapper: {
        css: css`
            display: flex;
            align-items: center;
        `,
    },
    updateQuantityLink: {
        typographyProps: {
            css: css`
                font-size: ${x => x.theme.design.typography.size.smallest};
            `,
        },
        icon: {
            iconProps: {
                src: Refresh,
                size: 16,
                color: "secondary",
            },
        },
        css: css`
            ${linkStyles()}
        `,
    },
    quantityUpdatedIcon: {
        src: CheckmarkCircle2Fill,
        size: 16,
        color: "success.main",
        css: css`
            margin-right: ${pxToRem(5)};
        `,
    },
    quantityUpdatedText: {
        css: css`
            color: ${getColor("success.main")};
            font-size: ${x => x.theme.design.typography.size.smallest};
        `,
    },
    restrictedDescriptionGridItem: {
        width: [12, 12, 6, 6, 5],
        printWidth: 5,
        css: css`
            flex-direction: column;
        `,
    },
    restrictedMessageText: { color: "warning" },
    actionDeleteButton: {
        color: "danger.light",
        css: css`
            ${({ theme }) => theme?.button?.defaultProps?.css}
            margin-left: ${pxToRem(5)};
            min-width: 0;
            padding: ${pxToRem(0, 5)};
        `,
    },
    trashIcon: {
        src: Trash2Fill,
        color: "danger",
    },
    productLineInfo: {
        width: productLineProps.productLineProductWidth,
    },
    productGridItem: {
        // Store Custom Code - added gap.
        ...productLineProps.productGridItem,
        css: css`
            ${productLineProps.productGridItem?.css}
            gap: .5rem;
        `,
        width: [12, 12, 12, 5, 5],
    },
    productControlsGridItem: { ...productLineProps.productControlsGridItem, width: 7 },
    productImageStyles: {
        linkWrappingImage: {
            css: css`
                ${productLineProps.productImage?.linkWrappingImage?.css}
                ${imageStyles(190 / 285)}
            `,
        },

        wrapper: {
            css: css`
                width: 100%;
            `,
        },
    },
    productBrandStyles: {
        nameText: {
            css: css`
                ${contentSpacingStyles(0, 0, pxToRem(5))}
            `,
        },
        nameLink: {
            css: css`
                ${contentSpacingStyles(0, 0, pxToRem(5))}
            `,
        },
    },
    productInfosWrapper: {
        ...productLineProps.productInfosWrapper,
        css: css`
            ${productLineProps?.productInfosWrapper?.css} padding-right: 1.5rem;
        `,
    },
    productDescriptionStyles: productLineProps.productDescription,
    productPartNumbersStyles: {
        erpNumberGridItem: {
            css: css`
                justify-content: "flex-start";
            `,
        },
        container: {
            css: css`
                flex-grow: 0;
            `,
        },
    },
    productPriceStyles: {
        priceWrapper: {
            css: css`
                display: flex;
            `,
        },
        wrapper: {
            css: css`
                margin-block: ${pxToRem(5)};
            `,
        },
        price: {
            unitOfMeasure: {
                unitOfMeasureText: {
                    css: css`
                        font-size: 1rem;
                        font-weight: 500;
                    `,
                },
            },
            unitOfMeasureText: {
                css: css`
                    font-size: 1rem;
                    font-weight: 500;
                `,
            },
            priceText: {
                color: "primary",
                css: css`
                    font-size: ${({ theme }) => theme.design.typography.size.base};
                    font-weight: ${({ theme }) => theme.design.typography.weight.medium};
                `,
            },
        },
    },
    productAvailabilityStyles: {
        wrapper: {
            css: css`
                max-width: 80% !important;
            `,
        },
    },
    productControls: productLineProps.productControls,
    productControlsItem: {
        css: css`
            display: flex;
            align-items: center;
            width: 100%;
            margin: 0.5em 0;
        `,
    },
    extendedUnitNetPriceText: productLineProps.extendedUnitNetPriceText,
    removeListLineIcon: productLineProps.removeProductLineIcon,
    mobileProductControls: productLineProps.mobileProductControls,
    productQuantityOrderedStyles: productLineProps.quantityOrdered,
    badgesGridItem: productLine.badgesGridItem,
    removeProductButton: {
        css: css`
            ${productLineProps.removeProductButton?.css}
            margin-left: ${pxToRem(10)};
        `,
    },
    wrapper: {
        css: css`
            display: flex;
            align-items: center;
        `,
    },
    mobileQtyAndExtendedPrice: {
        css: css`
            display: flex;
            margin-top: ${pxToRem(5)};
        `,
    },
};

const DragHandle = SortableHandle(() => {
    return (
        <StyledWrapper {...styles.sortOrderWrapper}>
            <Icon {...styles.dragHandleIcon} data-test-selector="myListDetailPage_DragSortOrder" />
        </StyledWrapper>
    );
});
/* Starter Custom Code - End */

/* Store Custom Code - Start */
const styles = productListLineStyles;
type NullablePricing = ProductPriceDto | null | undefined;

export const getBreakPrice = (pricing: NullablePricing, quantityOrdered: number): number | undefined => {
    const hasBreakPricing = pricing?.actualBreakPrices && pricing?.actualBreakPrices.length > 0;
    if (!hasBreakPricing) {
        return undefined;
    }
    const breakPrice = pricing?.actualBreakPrices?.find(({ breakQty }, index) => {
        const nextProduct = pricing?.actualBreakPrices?.[index + 1];
        const hasOrderedEnoughForBreakPrice = quantityOrdered >= breakQty;
        const nextProductDoesNotQualify = !nextProduct || quantityOrdered < nextProduct.breakQty;
        return hasOrderedEnoughForBreakPrice && nextProductDoesNotQualify;
    });

    return breakPrice?.breakPrice;
};
export const getUnitPrice = (pricing: NullablePricing, quantityOrdered: number): Decimal => {
    const priceFactor = Number(pricing?.additionalResults?.priceFactor) || 0;
    const unitPrice = getBreakPrice(pricing, quantityOrdered) || pricing?.actualPrice || 0;

    if (priceFactor > 1) {
        return new Decimal(unitPrice).dividedBy(priceFactor);
    }

    return new Decimal(unitPrice);
};

export const getExtendedPrice = (pricing: NullablePricing, quantityOrdered: number): number => {
    const unitPrice = getUnitPrice(pricing, quantityOrdered);
    const extendedPrice = unitPrice.times(quantityOrdered);
    return Number(extendedPrice.toFixed(2));
};

export const badgeSizes: BadgeSizes = {
    Small: {
        css: css`
            height: ${pxToRem(34)};
        `,
    },
    Medium: {
        css: css`
            height: ${pxToRem(34)};
        `,
    },
    Large: {
        css: css`
            height: ${pxToRem(50)};
        `,
    },
};
/* Store Custom Code - End */

const MyListsDetailsProductListLine: React.FC<Props> = ({
    wishList,
    wishListLine,
    productInfo,
    isSelected,
    settingsCollection,
    isQuantityUpdated,
    onDeleteClick,
    onEditNotesClick,
    updateWishListLineQuantities,
    setWishListLineIsSelected,
    updateUnitOfMeasure,
    updateQuantity,
    canDrag,
    isEditingSortOrder = false,
    updateWishListLine,
    showImageBadges,
    maximumNumberOfImageBadges,
    showTextBadges,
    maximumNumberOfTextBadges,
    // Store Custom Code
    customWishListLineUpdate,
    quantityUpdateOnSuccess,
}) => {
    const product = mapWishListLineToProduct(wishListLine);
    const canSeePrices = useCanSeePrices();
    const { minimumQuantity, multipleQuantity } = useHandleMinimumMultupleSalesQuantity(product, productInfo);

    const selectChangeHandler: CheckboxProps["onChange"] = (_, value) => {
        setWishListLineIsSelected({ wishListLineId: wishListLine.id, isSelected: value });
    };

    const onUpdateQuantityClick = () => {
        updateWishListLineQuantities({ reloadWishListLines: true, onSuccess: quantityUpdateOnSuccess });
    };

    const canEditWishList = wishList.allowEdit || !wishList.isSharedList;

    const deleteLabel = translate("Delete"); // Starter Custom Code
    const productContext: ProductContextModel = {
        product,
        productInfo,
        onQtyOrderedChanged: qtyOrdered => {
            updateQuantity({ wishListLineId: wishListLine.id, qtyOrdered });
        },
        onUnitOfMeasureChanged: unitOfMeasure => {
            updateUnitOfMeasure({ wishListLineId: wishListLine.id, unitOfMeasure });
        },
    };

    const { imageBadges, textBadges } = useWidgetBadges({ productContext, showTextBadges, showImageBadges });

    if (isWishListLineRestricted(wishListLine, productInfo) || isWishListLineDiscontinued(wishListLine, productInfo)) {
        return (
            <GridContainer
                {...styles.lineInnerContainer}
                data-test-selector={`${wishListLine.productId}_${wishListLine.selectedUnitOfMeasure}`}
            >
                <GridItem {...styles.restrictedDescriptionGridItem}>
                    <Typography {...styles.restrictedDescriptionText}>{wishListLine.shortDescription}</Typography>
                    <Hidden {...styles.partNumbersHidden}>
                        <ProductPartNumbers
                            productNumber={product.productNumber}
                            customerProductNumber={product.customerProductNumber}
                            manufacturerItem={product.manufacturerItem}
                            extendedStyles={styles.productPartNumbersStyles}
                        />
                    </Hidden>
                </GridItem>
                <GridItem {...styles.partNumbersGridItem}>
                    <ProductPartNumbers
                        productNumber={product.productNumber}
                        customerProductNumber={product.customerProductNumber}
                        manufacturerItem={product.manufacturerItem}
                        extendedStyles={styles.productPartNumbersStyles}
                    />
                </GridItem>
                <GridItem {...styles.priceAndAvailabilityGridItem}>
                    <Typography {...styles.restrictedMessageText} data-test-selector="restrictedMessage">
                        {isWishListLineRestricted(wishListLine, productInfo) && (
                            <>{siteMessage("Lists_Item_Not_Displayed_Due_To_Restrictions")}</>
                        )}
                        {isWishListLineDiscontinued(wishListLine, productInfo) && (
                            <>{siteMessage("Lists_Item_Not_Displayed_Due_To_Discontinued")}</>
                        )}
                    </Typography>
                </GridItem>
                <GridItem {...styles.buttonsGridItem}>
                    {canEditWishList && (
                        /* Starter Custom Code - Start */
                        <Clickable
                            {...styles.actionDeleteButton}
                            onClick={() => onDeleteClick(wishListLine)}
                            data-test-selector="removeRestricted"
                        >
                            <Icon {...styles.trashIcon} />
                            <VisuallyHidden>{deleteLabel}</VisuallyHidden>
                        </Clickable>
                        /* Starter Custom Code - End */
                    )}
                </GridItem>
            </GridContainer>
        );
    }

    const { productSettings } = settingsCollection;

    /* Store Custom Code - Start */
    const sortOrderBlurHandler = (event: React.FocusEvent<HTMLInputElement>) => {
        const sortOrder = Number(event.target.value);
        if (customWishListLineUpdate) {
            customWishListLineUpdate({ ...wishListLine, sortOrder });
            return;
        }
        updateWishListLine({
            wishListLine: { ...wishListLine, sortOrder },
            wishListId: wishList.id,
            wishListLineId: wishListLine.id,
        });
    };

    /* Store Custom Code - End */
    const extendedPrice = getExtendedPrice(productInfo.pricing, productInfo.qtyOrdered);
    return (
        <ProductContext.Provider value={productContext} {...styles.wrapper}>
            <GridContainer
                {...styles.lineInnerContainer}
                data-test-selector={`${wishListLine.productId}_${wishListLine.selectedUnitOfMeasure}`}
            >
                {/* Starter Custom Code */}
                <GridItem {...styles.productGridItem}>
                    {/* Store Custom Code - Start */}
                    {!isEditingSortOrder && (
                        <Checkbox
                            {...styles.selectedCheckbox}
                            checked={isSelected}
                            onChange={selectChangeHandler}
                            hiddenIconText={translate("Select")}
                            data-test-selector="selectItem"
                        />
                    )}
                    {isEditingSortOrder && (
                        <StyledWrapper {...styles.checkboxSortOrderWrapper}>
                            {canDrag && <DragHandle />}
                            <TextField
                                {...styles.sortOrderTextField}
                                label={translate("Sort Order")}
                                type="number"
                                min={1}
                                sizeVariant="small"
                                defaultValue={wishListLine.sortOrder}
                                onBlur={sortOrderBlurHandler}
                                data-test-selector="myListDetailPage_inputSortOrderLine"
                            />
                        </StyledWrapper>
                    )}
                    {/* Store Custom Code - End */}
                    <StyledWrapper {...styles.imageBadgeColumn}>
                        <ProductImage product={productContext} extendedStyles={styles.productImageStyles} />
                    </StyledWrapper>
                    {/* Starter Removed Code - Add/Edit Note */}
                    <StyledWrapper {...styles.productInfosWrapper}>
                        {product.brand && (
                            <ProductBrand brand={product.brand} extendedStyles={styles.productBrandStyles} />
                        )}
                        <ProductDescription product={productContext} extendedStyles={styles.productDescriptionStyles} />
                        <Hidden {...styles.partNumbersHidden}>
                            <ProductPartNumbers
                                productNumber={product.productNumber}
                                customerProductNumber={product.customerProductNumber}
                                manufacturerItem={product.manufacturerItem}
                                extendedStyles={styles.productPartNumbersStyles}
                            />
                            {wishListLine.notes && (
                                <SmallHeadingAndText
                                    heading={translate("Notes")}
                                    text={wishListLine.notes}
                                    extendedStyles={styles.notesStyles}
                                />
                            )}
                        </Hidden>
                        {/* Starter Removed Code - Overflow Action Menu */}
                        <Hidden {...styles.notesHidden}>
                            <GridItem {...styles.partNumbersGridItem}>
                                <ProductPartNumbers
                                    productNumber={product.productNumber}
                                    customerProductNumber={product.customerProductNumber}
                                    manufacturerItem={product.manufacturerItem}
                                    extendedStyles={styles.productPartNumbersStyles}
                                />
                            </GridItem>
                        </Hidden>

                        <ProductPrice
                            product={productContext}
                            showSavings={true}
                            showSavingsAmount={productSettings.showSavingsAmount}
                            showSavingsPercent={productSettings.showSavingsPercent}
                            extendedStyles={styles.productPriceStyles}
                            showLabel={false}
                        />
                        {(showTextBadges && textBadges?.length) || (showImageBadges && imageBadges?.length) ? (
                            <StyledWrapper {...styles.badgeWrapper}>
                                {showTextBadges && textBadges && (
                                    <ProductTextBadges
                                        badgeList={textBadges}
                                        maxBadges={maximumNumberOfTextBadges ?? 4}
                                        extendedStyles={styles.textBadgeStyles}
                                    />
                                )}
                                {showImageBadges && imageBadges && (
                                    <ProductImageBadges
                                        badgeSizes={badgeSizes}
                                        badgeList={imageBadges}
                                        maxBadges={maximumNumberOfImageBadges ?? 4}
                                        extendedStyles={styles.imageBadgeStyles}
                                        numberOfColumns={4}
                                    />
                                )}
                            </StyledWrapper>
                        ) : null}

                        <MinimumMultipleQuantityWarnings
                            minimumQuantity={minimumQuantity}
                            multipleQuantity={multipleQuantity}
                        />
                        {/* Store Custom Code */}
                        <ProductInventoryDetailMessage />
                        <PriceMatrix extendedStyles={styles.priceMatrixDesktop} />
                        {/* Bunzl removed - replaced with matrix */}
                        {/* <ProductQuantityBreakPricing extendedStyles={styles.quantityBreakPricing} /> */}
                        <StyledWrapper {...styles.mobileProductControls}>
                            {productSettings.showInventoryAvailability &&
                            product.trackInventory /* Starter Custom Code */ ? (
                                <StyledWrapper {...styles.productControlsItem}>
                                    <ProductContextAvailability extendedStyles={styles.productAvailabilityStyles} />
                                </StyledWrapper>
                            ) : (
                                <StyledWrapper {...styles.productControlsItem}>
                                    <Typography>{translate("Inventory Unavailable")}</Typography>
                                </StyledWrapper>
                            )}
                            <StyledWrapper {...styles.mobileQtyAndExtendedPrice}>
                                <ProductQuantityOrdered
                                    extendedStyles={styles.productQuantityOrderedStyles}
                                    labelOverride={false}
                                    // Starter Custom Code
                                    canEdit={canEditWishList}
                                />

                                <StyledWrapper {...styles.updateQuantityWrapper}>
                                    <Typography {...styles.extendedMobilePrice}>
                                        <LocalizedCurrency amount={extendedPrice} />
                                    </Typography>
                                    {canEditWishList &&
                                        productInfo.qtyOrdered > 0 &&
                                        wishListLine.qtyOrdered !== productInfo.qtyOrdered && (
                                            <Link
                                                {...styles.updateQuantityLink}
                                                onClick={() => onUpdateQuantityClick()}
                                            >
                                                {translate("Update QTY")}
                                            </Link>
                                        )}

                                    {isQuantityUpdated && wishListLine.qtyOrdered === productInfo.qtyOrdered && (
                                        <>
                                            <Icon {...styles.quantityUpdatedIcon} />
                                            <Typography {...styles.quantityUpdatedText}>
                                                {translate("QTY updated")}
                                            </Typography>
                                        </>
                                    )}
                                </StyledWrapper>
                            </StyledWrapper>
                            <StyledWrapper {...styles.productControlsItem}>
                                <AddToCartButtonWithIcon
                                    notes={wishListLine.notes}
                                    extendedStyles={styles.addToCartButton}
                                    data-test-selector="addToCart"
                                />
                            </StyledWrapper>
                            <PriceMatrix extendedStyles={styles.priceMatrixMobile} />
                        </StyledWrapper>
                    </StyledWrapper>
                </GridItem>
                <GridItem {...styles.productControlsGridItem}>
                    <StyledWrapper {...styles.productControls}>
                        <StyledWrapper {...styles.productControlsItem}>
                            {product.unitOfMeasures && product.unitOfMeasures.length > 1 && (
                                <ProductUnitOfMeasureSelect
                                    disabled={!canEditWishList}
                                    extendedStyles={styles.productUnitOfMeasureSelectStyles}
                                />
                            )}
                            <ProductQuantityOrdered
                                extendedStyles={styles.productQuantityOrderedStyles}
                                labelOverride={false}
                                // Starter Custom Code
                                canEdit={canEditWishList}
                            />

                            <StyledWrapper {...styles.updateQuantityWrapper}>
                                {canEditWishList &&
                                    productInfo.qtyOrdered > 0 &&
                                    wishListLine.qtyOrdered !== productInfo.qtyOrdered && (
                                        <Link {...styles.updateQuantityLink} onClick={() => onUpdateQuantityClick()}>
                                            {translate("Update QTY")}
                                        </Link>
                                    )}
                                {isQuantityUpdated && wishListLine.qtyOrdered === productInfo.qtyOrdered && (
                                    <>
                                        <Icon {...styles.quantityUpdatedIcon} />
                                        <Typography {...styles.quantityUpdatedText}>
                                            {translate("QTY updated")}
                                        </Typography>
                                    </>
                                )}
                            </StyledWrapper>
                        </StyledWrapper>
                        <StyledWrapper {...styles.productControlsItem}>
                            {canSeePrices && !product.quoteRequired && !productInfo.pricing?.requiresRealTimePrice && (
                                <Typography {...styles.extendedUnitNetPriceText}>
                                    <LocalizedCurrency amount={extendedPrice} />
                                </Typography>
                            )}
                        </StyledWrapper>
                        {productSettings.showInventoryAvailability && (
                            <StyledWrapper {...styles.productControlsItem}>
                                <ProductContextAvailability extendedStyles={styles.productAvailabilityStyles} />
                            </StyledWrapper>
                        )}

                        {wishListLine.notes && (
                            <Hidden {...styles.notesHidden}>
                                <GridItem {...styles.notesGridItem}>
                                    <SmallHeadingAndText
                                        heading={translate("Notes")}
                                        text={wishListLine.notes}
                                        extendedStyles={styles.notesStyles}
                                    />
                                </GridItem>
                            </Hidden>
                        )}
                        <StyledWrapper {...styles.productControlsItem}>
                            <AddToCartButtonWithIcon
                                notes={wishListLine.notes}
                                extendedStyles={styles.addToCartButton}
                                data-test-selector="addToCart"
                            />
                        </StyledWrapper>
                    </StyledWrapper>
                </GridItem>
            </GridContainer>
            {/* Starter Custom Code */}
            <StyledWrapper {...styles.deleteButtonWrapper}>
                <>
                    {canEditWishList && (
                        <Clickable
                            {...styles.removeProductButton}
                            onClick={() => onDeleteClick(wishListLine)}
                            data-test-selector="removeRestricted"
                        >
                            <IconMemo {...styles.removeListLineIcon} />
                            <VisuallyHidden>{translate("Removed this product")}</VisuallyHidden>
                        </Clickable>
                    )}
                </>
            </StyledWrapper>
        </ProductContext.Provider>
    );
};

const mapWishListLineToProduct = (wishListLine: WishListLineModel) => {
    const product = cloneDeep(wishListLine) as any as ProductModel;
    product.id = wishListLine.productId;
    product.productNumber = wishListLine.erpNumber;
    product.productTitle = wishListLine.shortDescription;
    product.unitOfMeasures =
        wishListLine?.productUnitOfMeasures?.map(u => ({
            id: u.productUnitOfMeasureId,
            ...u,
        })) || null;
    return product;
};

export default connect(mapStateToProps, mapDispatchToProps)(MyListsDetailsProductListLine);
